// import React from "react";
// import { Card, CardHeader, CardContent, Divider, Typography, Paper, Box, Button } from "@mui/material";

// const injectVariables = (text = "", variableMap = {}) => {
//   return String(text).replace(/\{\{(.*?)\}\}/g, (_, key) => {
//     const cleanKey = key.trim();
//     return variableMap?.[cleanKey] ?? `{{${cleanKey}}}`;
//   });
// };

// const EmailBlockPreview = ({ block, variableMap }) => {
//   if (!block?.type) return null;

//   switch (block.type) {
//     case "header":
//       return (
//         <Typography variant="h5" fontWeight={700} sx={{ mb: 1.5 }}>
//           {injectVariables(block.content, variableMap)}
//         </Typography>
//       );

//     case "text":
//       return (
//         <Typography variant="body1" sx={{ mb: 1.5, whiteSpace: "pre-wrap" }}>
//           {injectVariables(block.content, variableMap)}
//         </Typography>
//       );

//     case "image":
//       return (
//         <Box sx={{ mb: 2 }}>
//           {block.url ? (
//             <Box
//               component="img"
//               src={injectVariables(block.url, variableMap)}
//               alt={injectVariables(block.alt || "email-image", variableMap)}
//               sx={{
//                 width: "100%",
//                 maxHeight: 220,
//                 objectFit: "cover",
//                 borderRadius: 2,
//                 border: "1px solid",
//                 borderColor: "divider",
//               }}
//             />
//           ) : (
//             <Paper
//               variant="outlined"
//               sx={{ p: 3, textAlign: "center", borderRadius: 2, bgcolor: "grey.50" }}
//             >
//               <Typography variant="body2" color="text.secondary">
//                 Image preview
//               </Typography>
//             </Paper>
//           )}
//         </Box>
//       );

//     case "button":
//       return (
//         <Box sx={{ mb: 2 }}>
//           <Button variant="contained" disableElevation>
//             {injectVariables(block.label, variableMap)}
//           </Button>
//           <Typography variant="caption" display="block" sx={{ mt: 0.75 }}>
//             URL: {injectVariables(block.url, variableMap)}
//           </Typography>
//         </Box>
//       );

//     case "footer":
//       return (
//         <Typography
//           variant="body2"
//           color="text.secondary"
//           sx={{ mt: 2, pt: 2, borderTop: "1px solid", borderColor: "divider" }}
//         >
//           {injectVariables(block.content, variableMap)}
//         </Typography>
//       );

//     case "unsubscribe":
//       return (
//         <Typography variant="body2" sx={{ mt: 1.5, textDecoration: "underline" }}>
//           {injectVariables(block.text, variableMap)}
//         </Typography>
//       );

//     default:
//       return null;
//   }
// };

// const EmailPreview = ({ form, variableMap = {} }) => {
//   return (
//     <Card variant="outlined" sx={{ borderRadius: 3 }}>
//       <CardHeader
//         title={
//           <>
//             <Typography variant="subtitle2" color="text.secondary">
//               Subject
//             </Typography>
//             <Typography variant="h6">
//               {injectVariables(form.subject || "No subject", variableMap)}
//             </Typography>
//           </>
//         }
//         subheader={
//           <>
//             <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>
//               Preview text
//             </Typography>
//             <Typography variant="body2">
//               {injectVariables(form.preview_text || "No preview text", variableMap)}
//             </Typography>
//           </>
//         }
//       />
//       <Divider />
//       <CardContent sx={{ bgcolor: "#fafafa" }}>
//         <Paper
//           elevation={0}
//           sx={{
//             p: 3,
//             borderRadius: 3,
//             bgcolor: "#fff",
//             border: "1px solid",
//             borderColor: "divider",
//             minHeight: 350,
//           }}
//         >
//           {(form?.body_json?.blocks || []).map((block, idx) => (
//             <EmailBlockPreview
//               key={`${block.type}-${idx}`}
//               block={block}
//               variableMap={variableMap}
//             />
//           ))}
//         </Paper>
//       </CardContent>
//     </Card>
//   );
// };

// export default EmailPreview;

import React from "react";
import { Card, CardContent, Typography, Paper, Box, Button, Divider, Stack, Chip } from "@mui/material";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const injectVariables = (text = "", variableMap = {}) =>
  String(text).replace(/\{\{(.*?)\}\}/g, (_, key) => variableMap?.[key.trim()] ?? `{{${key.trim()}}}`);

const EmailBlockPreview = ({ block, variableMap }) => {
  if (!block?.type) return null;
  switch (block.type) {
    case "header":
      return <Typography variant="h5" fontWeight={700} sx={{ mb: 1.5, color: accent }}>{injectVariables(block.content, variableMap)}</Typography>;
    case "text":
      return <Typography variant="body1" sx={{ mb: 1.5, whiteSpace: "pre-wrap", lineHeight: 1.7, color: "#333" }}>{injectVariables(block.content, variableMap)}</Typography>;
    case "image":
      return (
        <Box sx={{ mb: 2 }}>
          {block.url ? (
            <Box component="img" src={injectVariables(block.url, variableMap)} alt={injectVariables(block.alt || "", variableMap)}
              sx={{ width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: 2, border: "1px solid #e3e8f0" }} />
          ) : (
            <Paper variant="outlined" sx={{ p: 3, textAlign: "center", borderRadius: 2, bgcolor: accentLight }}>
              <Typography variant="body2" color="text.secondary">Image preview</Typography>
            </Paper>
          )}
        </Box>
      );
    case "button":
      return (
        <Box sx={{ mb: 2 }}>
          <Button variant="contained" disableElevation sx={{ background: `linear-gradient(135deg, ${accent}, #1565c0)`, borderRadius: 2, px: 4, py: 1.2, textTransform: "none", fontWeight: 600 }}>
            {injectVariables(block.label, variableMap)}
          </Button>
          <Typography variant="caption" display="block" sx={{ mt: 0.75, color: "#999" }}>URL: {injectVariables(block.url, variableMap)}</Typography>
        </Box>
      );
    case "footer":
      return <Typography variant="body2" sx={{ mt: 2, pt: 2, borderTop: "1px solid #e3e8f0", color: "#999" }}>{injectVariables(block.content, variableMap)}</Typography>;
    case "unsubscribe":
      return <Typography variant="body2" sx={{ mt: 1.5, textDecoration: "underline", color: accent, cursor: "pointer" }}>{injectVariables(block.text, variableMap)}</Typography>;
    default: return null;
  }
};

const EmailPreview = ({ form, variableMap = {} }) => {
  return (
    <Card elevation={0} sx={{ borderRadius: 3, border: "1px solid #e3e8f0", overflow: "hidden", position: "sticky", top: 20 }}>
      {/* Header */}
      <Box sx={{ p: 2.5, background: `linear-gradient(135deg, ${accent}, #1565c0)`, color: "#fff" }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <PreviewOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography variant="subtitle2" fontWeight={600}>Live Preview</Typography>
        </Stack>
      </Box>

      {/* Subject & Preview */}
      <Box sx={{ px: 3, py: 2, backgroundColor: accentLight }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
          <SubjectOutlinedIcon sx={{ fontSize: 16, color: accent }} />
          <Typography variant="caption" fontWeight={600} color={accent}>SUBJECT</Typography>
        </Stack>
        <Typography variant="subtitle1" fontWeight={600} sx={{ color: "#1a1a2e" }}>
          {injectVariables(form.subject || "No subject", variableMap)}
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5, color: "#666" }}>
          {injectVariables(form.preview_text || "No preview text", variableMap)}
        </Typography>
      </Box>

      <Divider />

      {/* Email Body */}
      <CardContent sx={{ bgcolor: "#fafbfc", p: 3 }}>
        <Paper elevation={0} sx={{ p: 3, borderRadius: 3, bgcolor: "#fff", border: "1px solid #e3e8f0", minHeight: 300 }}>
          {(form?.body_json?.blocks || []).map((block, idx) => (
            <EmailBlockPreview key={`${block.type}-${idx}`} block={block} variableMap={variableMap} />
          ))}
        </Paper>
      </CardContent>
    </Card>
  );
};

export default EmailPreview;
